import {post} from '../utils'
import {getActiveClient} from "../authentication/utils";

export default host => (files) => {
  const fileFormData = new FormData()
    fileFormData.append('files_ids[]', files)

  return post(`${host}/clients/${getActiveClient()}/reel/custom`, fileFormData)
      .then(response => response.json())
}